<template>
  <div class="section">
    <h3 class="section-title">{{ user.id > -1 ? `${user.name} szerkesztése` : 'Új felhasználó' }}</h3>
    <div class="section-content">
      <b-alert
        variant="success"
        :show="message.length > 0"
      >
        {{ message }}
      </b-alert>
      <b-form-group
        :state="nameState && errors$name.length < 1"
        :invalid-feedback="errors$name"
      >
        <label for="name">Név</label>
        <b-form-input
          id="name"
          v-model="name"
          :state="nameState && errors$name.length < 1"
          type="text"
          placeholder="A felhasználó neve"
          required
        />
      </b-form-group>
      <b-form-group
        :state="emailState && errors$email.length < 1"
        :invalid-feedback="errors$email"
      >
        <label for="email">Email</label>
        <b-form-input
          id="email"
          v-model="email"
          :state="emailState && errors$email.length < 1"
          type="email"
          placeholder="A felhasználó email címe"
          required
        />
      </b-form-group>
      <customer-select
        :customer-state="customerState && errors$customer_id.length < 1"
        :customer-error.sync="errors$customer_id"
        :customer-id.sync="customer_id"
      />
      <b-form-group
        :state="errors$lang.length < 1"
        :invalid-feedback="errors$lang"
      >
        <label for="name">Nyelv</label>
        <b-form-select
          v-model="lang"
          :state="errors$lang.length < 1"
          :options="$store.state.userLangs"
        />
      </b-form-group>
      <b-form-group
        :state="errors$makeAdmin.length < 1"
        :invalid-feedback="errors$makeAdmin"
      >
        <b-form-checkbox
          id="makeAdmin"
          v-model="makeAdmin"
          :value="true"
          :unchecked-value="false"
        >
          Ez a felhasználó admin
        </b-form-checkbox>
      </b-form-group>
      <div class="section-divider" />
      <b-form-group
        class="text-right"
      >
        <div class="row">
          <div class="col-6 text-left">
            <b-button
              :href="$url('users.index')"
            >
              <span>Vissza</span>
            </b-button>
          </div>
          <div class="col-6">
            <b-button
              :disabled="saving || !validUser"
              variant="success"
              @click="save"
            >
              <span>Mentés</span>
              <b-spinner
                v-show="saving"
                variant="light"
                label="Mentés"
                small
              />
            </b-button>
          </div>
        </div>
      </b-form-group>
    </div>
  </div>
</template>
<script>
import CustomerSelect from '../customer/CustomerSelect'

import FormValidation from '../../utils/mixins/FormValidation'
import ErrorHandler from '../../utils/mixins/ErrorHandler'

export default {
  components: {
    'customer-select': CustomerSelect
  },
  mixins: [
    FormValidation(['name', 'email', 'customer_id', 'makeAdmin', 'lang']),
    ErrorHandler()
  ],
  props: {
    user: {
      type: Object,
      default: () => ({
        id: -1,
        name: '',
        email: '',
        customer_id: -1,
        lang: 'hu',
      })
    },
    isAdmin: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      id: -1,
      name: '',
      email: '',
      lang: 'hu',
      customer_id: -1,
      makeAdmin: false,
      customers: [
        {value: null, text: 'Válassz egy ügyfelet'}
      ],
      saving: false,
      message: ''
    }
  },
  computed: {
    nameState: function() {
      return this.name.length > 0
    },
    emailState: function() {
      return this.validateEmail(this.email)
    },
    customerState: function() {
      return this.customer_id !== -1
    },
    validUser: function() {
      return this.nameState && this.emailState && this.customerState
    }
  },
  mounted() {
    _.forEach(this.user, (value, name) => {
      this[name] = value
    })

    this.makeAdmin = this.isAdmin

    this.$http.get(this.$url('api.customers.index'))
      .then(({data}) => {
        if(data.customers) {
          _.forEach(data.customers, customer => this.customers.push({text: customer.name, value: customer.id}))
        }
      })
  },
  methods: {
    save() {
      if(!this.validUser) {
        return
      }

      this.clearErrors()
      this.message = ''
      this.saving = true

      const path = this.id > -1 ? this.$url('api.users.update', this.id): this.$url('api.users.store')
      const method = this.id > -1 ? 'patch' : 'post'

      this.$http[method](path, {
        id: this.id,
        name: this.name,
        customer_id: this.customer_id,
        makeAdmin: this.makeAdmin,
        email: this.email,
        lang: this.lang
      })
        .then(({data}) => {
          if(data.user) {
            this.name = data.user.name
            this.id = data.user.id

            window.location = this.$url('users.index')

            this.message = 'Sikeres mentés'
          } else {
            this.handleError('Hiba történt a mentés közben')
          }
        })
        .catch(this.handleErrors)
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>